import React, { useEffect } from 'react';
import queryString from 'query-string';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import LoginForm from './LoginForm';
import './style.scss';

const Login = ({translate, location}) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location?.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.body.className = 'maxfibra-oauth-body';
    document.title = 'Max Fibra';
  }, []);

  return (
    <div className="maxfibra-oauth">
      {
        _validateParams()
          ? <LoginForm
          api={api}
          location={location} />
          :<RequestLoginErrorMessage
          onlyMessage={true}
          message={translate('RequestLoginErrorMessage')} />}
    </div>
  );
}

export default WithLocalize(Login);
